module.exports = __webpack_public_path__ + "static/media/help_import.a53a5bbd.png";